import { useTLang } from 'intl/intl';
import { splitByLastFourDigits } from 'shared/utils/numbers';

import makeClasses from './ComplaintComment.style';

import type { MozartComplaintComment } from 'features/mozart-notifications/domain';

export function ComplaintComment(props: MozartComplaintComment) {
  const { id, reason, description, imageUrl } = props;

  const lang = {
    id: 'ID',
    reason: useTLang({ id: 'notification.mozart.037' }),
    comment: useTLang({ id: 'notification.mozart.020' }),
    photo: useTLang({ id: 'notification.mozart.023' }),
  };

  const _classes = makeClasses();

  const idDivided = splitByLastFourDigits(id);

  if (isNaN(id) || !reason) return null;
  return (
    <article className={_classes.card}>
      <section className={_classes.mainSection}>
        <div>
          <h5>{lang.id}</h5>
          <p>
            {idDivided[0]}
            <span className='bold'>{idDivided[1]}</span>
          </p>
        </div>
        <div>
          <h5>{lang.reason}</h5>
          <p>{reason}</p>
        </div>
      </section>
      <aside>
        <div>
          <h5>{lang.comment}</h5>
          <p>{description}</p>
        </div>
        {!!imageUrl && (
          <div className={_classes.imageContainer}>
            <h5>{lang.photo}</h5>
            <img src={imageUrl} alt='Imagen del comentario' />
          </div>
        )}
      </aside>
    </article>
  );
}
